/*
 * @Author: LiuChuanQi
 * @Date: 2022-11-28 10:31:27
 * @LastEditTime: 2023-02-02 14:57:43
 * @LastEditors: LiuChuanQi
 * @Description: 登录模块状态管理
 * @FilePath: \speedtest-bigdata-v2\src\store\modules\login.js
 * 
 */
//导入自己封装的localStorage方法
import { storage } from '@/utils/hooks/index'

const login = {
  namespaced: true,//vuex使用createNamespacedHelpers不生效（一定要与namespaced一块使用）
  state: {
    // 存储token
    access_token: "",  //过期一天
    refresh_token: "", //过期七天
    user_name: "", // 可选
    is_login: false,
    is_member: false, //是否是会员身份
    token_type: '',// token类型
    open_page: false,//是否打开找回密码的页面
    userInfor: {},//登录成功用户信息
    backUrl: '',//登录成功跳转路径
    effect_end_date:'' //会员过期时间
  },
  getters: {
    getToken (state) {
      return state.access_token || storage.get("access_token") || ""
    },
    getRefreshToken (state) {
      return state.refresh_token || storage.get("refresh_token") || ""
    },
    getTokenType (state) {
      return state.token_type || storage.get("token_type") || ""
    },
    getIsLogin (state) {
      return state.is_login || storage.get("is_login") || false
    },
    getIsMemver (state) {
      return state.is_member || storage.get("is_member") || false
    },
    getUserInfor (state) {
      return state.userInfor || storage.get("userInfor") || false
    },
    getEndDateTime (state) {
      return state.effect_end_date || storage.get("effect_end_date") || false
    }
  },
  mutations: {
    /**
     * 修改login state中的值
     * @param {*} state state对象
     * @param {*} value 
     * @param {*} key 
     */
    setValue (state, [value, key]) {
      state[key] = value
      storage.set(key, value)
      //console.log(key + 'localstorage保存成功！')
    },
    /**
     * 删除全局状态
     * @param {*} state 
     * @param {*} key 
     */
    delValue (state, key) {
      state[key] = ""
      storage.remove(key)
    },
  },
  actions: {

  },

}

export default login
